"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVariableStatement = isVariableStatement;
exports.hasStatementOutcomeActions = hasStatementOutcomeActions;
exports.getPredicateFnWhenRemoveVariable = getPredicateFnWhenRemoveVariable;
exports.getVariablesMappingOnCopy = getVariablesMappingOnCopy;
var outcome_type_1 = require("../outcome/outcome-type");
var advanced_logic_error_1 = require("./advanced-logic-error");
function isVariableStatement(statement) {
    return statement.outcome.type === outcome_type_1.OutcomeType.Variable;
}
function hasStatementOutcomeActions(statement, outcomeTypes) {
    if (outcomeTypes === void 0) { outcomeTypes = outcome_type_1.OutcomeTypesWithActions; }
    return outcomeTypes.includes(statement.outcome.type);
}
function getPredicateFnWhenRemoveVariable(property) {
    switch (property) {
        case outcome_type_1.OutcomeActionProperties.Value:
            return function (condition, value) {
                return condition.value === value;
            };
        case outcome_type_1.OutcomeActionProperties.Id:
            return function (condition, value) {
                return condition.context
                    ? condition.context.variableId === value
                    : false;
            };
        default:
            throw new advanced_logic_error_1.AdvancedLogicError("Property ".concat(property, " is not supported"));
            break;
    }
}
function getVariablesMappingOnCopy(variables) {
    if (variables === void 0) { variables = []; }
    return variables.reduce(function (accumulator, variable) {
        var _a;
        return variable.values.reduce(function (acc, variableValue) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[variableValue.oldRefId] = variableValue.newRefId, _a)));
        }, __assign(__assign({}, accumulator), (_a = {}, _a[variable.oldRefId] = variable.newRefId, _a)));
    }, {});
}
